module.exports = __webpack_public_path__ + "media/images/admin/icons/toggle-right-adb79d3720b591e6c9482546042973e5.svg";